import styled from "styled-components";

export const OmKort = styled.div`
  min-width: 250px;
  max-width: 250px;
  height: max-content;
  flex-grow: 0;
  flex-srink: 0;
  padding: 15px 25px;
  margin: 0;
  border-radius: 15px;
  box-shadow: 0 8px 15px 0 rgb(0 0 29 / 7%);
  background-color: #fefefe;
  transition: all 250ms ease-out;
  & h2 {
    transition: color 250ms ease-out;
    color: black;
    margin: 0;
    padding: 0;
  }
  & .description {
    display: grid;
    font-size: 1.2rem;
    position: relative;
    z-index: 2;
    animation-duration: 350ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
  }
  @media screen and (max-width: 1050px){
    width: 40%;
    max-width: 40%;
    min-height: 250px;
  }
  @media screen and (max-width: 768px){
    width: 100%;
    max-width: 100%;
    min-height: 250px;
  }
`;